import isNil from 'lodash-es/isNil'

import { HOUR_FIRST_MINUTE } from '../../../../../../constants/date'
import { getCalendarGridSelectionBounds } from '../../../../CalendarGrid.utils'
import { getCalendarGridDayTime } from '../../../../CalendarGrid.utils.time'

function getIsCalendarGridWeekAllDayIndexInSelection({ dayIndex, selection }) {
  const { from, to } = getCalendarGridSelectionBounds(selection)

  return dayIndex >= from && dayIndex <= to
}

export function getCalendarGridWeekAllDayNextSelection({
  dayIndex,
  selection,
}) {
  return isNil(selection) ? selection : { ...selection, focus: dayIndex }
}

export function getIsCalendarGridWeekAllDaySelected({ dayIndex, selection }) {
  return (
    !isNil(selection) &&
    getIsCalendarGridWeekAllDayIndexInSelection({ dayIndex, selection })
  )
}

export function getCalendarGridWeekAllDaySelectionDays({
  days,
  selection,
  timezone,
}) {
  const { from, to } = getCalendarGridSelectionBounds(selection)

  return {
    firstDay: getCalendarGridDayTime({
      day: days[from].date,
      minutes: HOUR_FIRST_MINUTE,
      timezone,
    }),
    lastDay: getCalendarGridDayTime({
      day: days[to].date,
      minutes: HOUR_FIRST_MINUTE,
      timezone,
    }),
  }
}
